import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import "./FooterSection.css"

const footerColumns = [
  {
    heading: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    heading: "Products",
    links: [
      { label: "Reflective Sheeting", href: "/products/avery-dennison-reflective-sheeting" },
      { label: "Road Studs & Markers", href: "/products/rayolite-marker-road-studs" },
      { label: "Solar Cat's Eyes", href: "/products/solar-cats-eyes" },
      { label: "Crash Cushions", href: "/products/sma-crash-cushions" },
    ],
  },
  {
    heading: "Support",
    links: [
      { label: "Send Us a Message", href: "/contact" },
      { label: "Installation Guides", href: "/contact" },
      { label: "Warranty Claims", href: "/contact" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Certifications", href: "/about" },
    ],
  },
]

const socialLinks = [
  { icon: FaFacebookF, href: "#", label: "Facebook" },
  { icon: FaInstagram, href: "#", label: "Instagram" },
  { icon: FaLinkedinIn, href: "#", label: "LinkedIn" },
];

export function FooterSection() {
  const { t } = useTranslation()
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__columns">
          {footerColumns.map((col) => (
            <div key={col.heading} className="footer__col">
              <h3 className="footer__col-heading">{t(col.heading)}</h3>
              <ul className="footer__col-list">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="footer__col-link">
                      {t(link.label)}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer__divider" />

        <div className="footer__cta-row">
          <a href="/" className="footer__logo">
            <span className="footer__logo-badge">
              <img src="/images/roads-reflectors-logo.webp" alt="Road's Reflectors company logo" />
            </span>
            <span className="footer__logo-text">
              <span className="footer__logo-title">
                Road&apos;s <span>Reflectors</span>
              </span>
              <span className="footer__logo-sub">{t("Road Safety Solutions")}</span>
            </span>
          </a>

          <div className="footer__cta">
            <span className="footer__cta-text">{t("Ready to make your roads safer?")}</span>
            <a href="/contact" className="btn-pill btn-pill--brand">
              {t("Contact Us")}
              <span className="btn-pill__arrow">
                <ArrowUpRight size={14} />
              </span>
            </a>
          </div>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <p className="footer__copyright">
            {t("Copyright © Road's Reflectors {{year}}. All Rights Reserved.", { year: new Date().getFullYear() })}
          </p>

         {/**  <div className="footer__legal">
            <a href="#" className="footer__legal-link">Terms of Use</a>
            <a href="#" className="footer__legal-link">Privacy Policy</a>
          </div>**/}

          <div className="footer__socials">
            {socialLinks.map((social) => {
              const Icon = social.icon
              return (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="footer__social-link"
                >
                  <Icon size={16} />
                </a>
              )
            })}
          </div>
        </div>
      </div>
    </footer>
  )
}
